import * as React from 'react';
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { __set, __remove } from "src/store/axios_indicator";
import Constants from 'src/helper/Constants';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const ClearSingleCartProductFromCart = (props) => {
    const { translation:t } = System;
    const [{ CART_COUNT }, { clear_single_cart_product, get_Validate_Cart_From_Server }, { set_cart_loader_data_object }] = useCartStore()
    const { currentCartItem, cartType } = props;
    const [{ }, { system_alert_indicator, clear_all_system_alert }, { }] = useDOMAttachToSystemStore();
    const ClearSingleCartProductFromCart = async () => {
        let data;
        __set('MINI_CART_API_CALL');
        await clear_single_cart_product({ cartDetailId: currentCartItem.cartDetailId, miniCart: true }).then((res) => data = res)
        __remove('MINI_CART_API_CALL');
        if (data.isSuccessFull) {
            clear_all_system_alert({})
            if (CART_COUNT > 1) {
                get_Validate_Cart_From_Server()
            }
            if (cartType === Constants.systemModules.CART) {
                system_alert_indicator({
                    name: 'removeSinglePartFromCart',
                    message: t('partSuccessfullyRemovedFromYourCart'),
                    type: "success"
                })
            }
            let cartRemoval = { ...currentCartItem, ERPSupplierCode: currentCartItem?.erpManufacturerCode }
              if (Object.keys(cartRemoval).length > 0) {
                HelperAnalyticsEvent.cartEvent({ productList: [cartRemoval], eventName: 'cartRemoval' });
              }
            set_cart_loader_data_object({})
        }

    };


    return (
        <React.Fragment>
            <div onClick={() => {
                ClearSingleCartProductFromCart();
            }}>
                {props.children}
            </div>
        </React.Fragment>
    );
};


export default ClearSingleCartProductFromCart;